'use client';

import { buyRecommendedProducts } from 'actions/services';
import config from 'config';

import { Flex, Stack, useTheme } from '@chakra-ui/react';

import { useAppDispatch, useAppSelector } from 'store/hooks';

import { Button, Divider, MultiStepHeader } from 'ui';
import { RecommendedItem } from './components';

const {
  booking: {
    recommendedStep: { title, description, paddings }
  }
} = config;

interface RecommendedStepProps {
  onNext: () => void;
}

const RecommendedStep = ({ onNext }: RecommendedStepProps) => {
  const dispatch = useAppDispatch();
  const {
    colors: {
      palette: {
        booking: { stepRecommended }
      }
    }
  } = useTheme();

  const {
    recommendedProducts,
    selectedProducts = [],
    checkoutData
  } = useAppSelector((state) => state.bookingAppointment);

  const confirmHandler = () =>
    checkoutData?.appt_id
      ? dispatch(
          buyRecommendedProducts(selectedProducts, checkoutData.appt_id, onNext)
        )
      : onNext;

  return (
    <Stack w='100%' mx='auto' gap={0}>
      <MultiStepHeader
        title={title}
        subTitle={description}
        headingColor={stepRecommended.headingColor}
        descriptionColor={stepRecommended.descriptionColor}
        mt='20px'
        mb={['10px', '15px', '20px']}
        descriptionPX={paddings}
      />

      <Divider
        h='1px'
        bg={stepRecommended.dividerColor}
        border='none'
        my='10px'
      />

      <Stack
        overflow='hidden'
        gap={0}
        overflowY='scroll'
        css={{
          '&::-webkit-scrollbar': {
            width: '6px',

            '&-track': {
              width: '8px'
            },
            '&-thumb': {
              background: stepRecommended.dividerColor,
              borderRadius: '24px'
            }
          }
        }}
      >
        {recommendedProducts.map((product, index) => (
          <Stack
            gap='5px'
            w='100%'
            key={product?.id}
            bg={stepRecommended.list.background}
          >
            <RecommendedItem
              item={product}
              isLastItem={recommendedProducts.length - 1 === index}
            />
          </Stack>
        ))}
      </Stack>

      <Divider
        h='1px'
        bg={stepRecommended.dividerColor}
        mt='10px'
        border='none'
      />

      <Stack gap='30px'>
        <Flex
          direction={{ base: 'column-reverse', md: 'row' }}
          mt='60px'
          justifyContent='center'
          alignItems='center'
          gap='20px'
          w='100%'
        >
          <Button variant='outline' w='150px' h='45px' onClick={onNext}>
            skip
          </Button>
          <Button
            w='150px'
            h='45px'
            onClick={confirmHandler}
            isDisabled={!selectedProducts.length}
          >
            next
          </Button>
        </Flex>
      </Stack>
    </Stack>
  );
};

export default RecommendedStep;
